import $ from 'jquery';
import Backbone from 'backbone';

import { makeAlert, displayNotificationForXhrFail } from 'zoomforth_tools/modern_helpers.js';
import MediaLibraryAsset from 'zoomforth_media_library/models/media_library_asset.js';

import addYoutubeModalTemplate from './global.add_youtube_modal.tpl';

const AddYoutubeModal = Backbone.View.extend({
  className: "youtube-upload-modal modal hide",

  template: addYoutubeModalTemplate,

  events: {
    'keyup .youtubeLinkInput': 'onChange',
    'change .youtubeLinkInput': 'onChange',
    'click .submitYoutubeVideo': 'submit',
    'click .previewYoutubeVideo': 'preview',
    'hidden': 'hidden'
  },
  
  initialize: function(){
    this.youtubeId = null;
    this.deferred = $.Deferred();
  },
  
  render: function(){
    this.$el.html(this.template({}));
    return this;
  },
  
  show: function(){
    this.render();
    this.$el.modal({
      focusOn:'.youtubeLinkInput'
    });
    return this.deferred.promise();
  },
  
  hidden: function(){
    this.remove();
  },
  
  remove: function(){
    if(this.deferred.state() == 'pending'){
      this.deferred.reject();
    }
    AddYoutubeModal.__super__.remove.call(this);
  },
  
  onChange: function(e){
    var currentId = this._urlParse(this.$('.youtubeLinkInput').val());
    if(currentId){
      if(this.youtubeId===null || currentId != this.youtubeId){
        this.youtubeId = currentId;
        this.$('.youtubeLinkInput').css('border','1px solid green');
        this.$('.previewYoutubeVideo').show();
      }
    } else{
      this.youtubeId = null;
      this.$('.previewYoutubeVideo').hide();
      this.$('.youtubeLinkInput').css('border','1px solid red');
    }
  },
  
  submit: function(){
    var me = this;
    if (this.youtubeId === null){
      makeAlert('That is not a valid YouTube link or video ID');
      return;
    }
    this._getTitle().done(function(resultsFromYoutube){
      if(resultsFromYoutube !== null){
        if(me.youtubeId.length != 11){
          makeAlert('That is not a valid YouTube video ID');
          return;
        }
        $.ajax({
          url : '/video/youtube/create',
          data: {
            youtube_id: me.youtubeId,
            title: resultsFromYoutube.title,
            caption: resultsFromYoutube.description
          },
          dataType: 'json',
          type: 'post',
          success: function(response){
            // KOTZ TODO -- This is a little weird, since we could be using the new style asset
            // rest API to create this youtube asset, rather than doing this RPC thing and then making
            // the model on success. But for now this will work and it will be up to future me to make
            // this a little cleaner. Thanks past me.
            response.assetId = response.id;
            response.id = response.assetType + '-' + response.id;
            var youtubeAsset = new MediaLibraryAsset(response);
            me.deferred.resolve(youtubeAsset);
            me.$el.modal('hide');
          },
          error: displayNotificationForXhrFail
        });
      }
    });
    
  },
  
  preview: function(){
    $.fancybox.open(MediaLibraryAsset.fancyboxSettings(this.youtubeId));
  },
  
  _getTitle: function(){
    var gotTitle = $.Deferred();
    var youtubePublicApiKey = 'AIzaSyCIPjSeVksa1KNeNmMxKZfP7Y1oZpMxE9Y';
    
    $.ajax({
      url: 'https://www.googleapis.com/youtube/v3/videos?id='+this.youtubeId+'&key='+youtubePublicApiKey+'&part=snippet',
      dataType: "jsonp",
      success: function (data) { 
        if (typeof(data.items[0]) != "undefined") {
          var title = data.items[0].snippet.title;
          var description = data.items[0].snippet.description;
          gotTitle.resolve({title:title, description:description});
        } else {
          gotTitle.resolve(null);
        }  
      },
      error: function(){
        gotTitle.resolve(null);
      }
    });
    return gotTitle.promise();
  },
  
  _urlParse: function(url){
    if (url.length == 11 && url.indexOf(':') === -1){
      return url;
    }
    var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch.*(?:\?|\&)v=)([^#\&\?]*).*/;
    var match = url.match(regExp);
    if (match&&match[1].length==11){
      return match[1];
    } else{
      return false;
    }
  }
});

export default AddYoutubeModal;
